import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { HotelReservationRoom } from '@bandido/shared/types';
import type { HotelFare } from './searchModel';

export function HotelReservationRoomHeader({
  room,
  boardCode,
}: {
  room: HotelReservationRoom | HotelFare['room_stays'][number];
  boardCode?: string | null;
}) {
  const { t } = useTranslation();
  const code = boardCode ?? room.board_basis;
  const sameBoard = code === room.board_basis;
  const name = sameBoard && 'board_display_name' in room ? room.board_display_name : null;
  const category = sameBoard && 'board' in room ? room.board?.category : null;
  const board =
    name ||
    (category && category !== 'unknown'
      ? t(`hotelSearch.boards.${category}`)
      : code
        ? t('hotelReservation.boardValue', { code })
        : t('hotelReservation.notReported'));
  return (
    <Stack spacing={0.5} sx={{ p: 2, bgcolor: 'action.hover', borderBottom: 1, borderColor: 'divider' }}>
      <Typography variant="overline">{t('hotelReservation.room', { room: room.room_index + 1 })}</Typography>
      <Typography fontWeight={600}>{room.room_name || t('hotelReservation.roomTypeUnknown')}</Typography>
      <Typography variant="body2">
        {t('hotelSearch.boardFilter')}: {board}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {t('hotelReservation.roomAdults', { count: room.adults })}
        {room.children_ages.length > 0
          ? ` · ${t('hotelReservation.roomChildren', { count: room.children_ages.length })}`
          : ''}
      </Typography>
    </Stack>
  );
}
